



import './App.css';
import Background from './Background';
import { useEffect } from 'react';


import Sidebar from './Sidebar';



import Cert from './Cert';


import Copy from './Copy';

import Habtext from './Habtext';

import Valores from './Valores';


import Infos from './Infos';
import Logo from './Logo';

import Qualidade from './Qualidade';
import EmblaCarousel from './EmblaCarousel';








function App() {
  useEffect(() => {
    const handleWheel = (e) => {
      if (e.ctrlKey) e.preventDefault();
    };

    const handleKeydown = (e) => {
      if ((e.ctrlKey && ['+', '-', '='].includes(e.key)) || e.key === 'Meta') {
        e.preventDefault();
      }
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('keydown', handleKeydown);

    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  return (
    <div className="app-container">



      <Sidebar />

      <main className='main'>

        <section className="" > <Background /></section>
        <section className="section"> <Habtext /></section>
        <section className="section1"> <Valores /></section>
        <section className="section1"> <Qualidade /></section>
         <section className="section1"><EmblaCarousel /></section>
 

        <section className="section3"><Logo /></section>
        <section className="section1"><Cert /></section>
   


        <section className="section5"><Infos /></section>

        <section ><Copy /></section>


      </main>

    </div>
  );
}

export default App;